export default __webpack_public_path__ + "static/media/pwa.4f9edd63.png";